<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <payment user_id=""></payment>
                <reservations :company="company"
                              :user_id="user_id == null ? null : user_id"
                              @reservationCanceled="$refs.calendar.ajaxEvents()"
                              @reservationsExpired="$refs.calendar.ajaxEvents()"
                              ref="reservations"
                              :consultant="consultant"
                ></reservations>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-rounded card-transparent">
                    <div class="card-header">{{company.name}} <span v-if="consultant"> - {{transEdit('consultant')}}</span></div>
                    <div class="card-body" id="#booking-calendar">
                        <button class="btn btn-secondary" @click="showFilters = !showFilters"><i class="fa fa-filter"></i> {{transEdit('filter')}}</button>
                        <p class="text-muted pt-2" v-text="transEdit('booking-filter-text')"> </p>
                        <div class="row mt-2" v-if="showFilters">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>{{transEdit('locations')}}</label>
                                    <multiselect
                                            v-model="selectedLocations"
                                            :options="filterLocations"
                                            track-by="name"
                                            label="name"
                                            :showLabels="false"
                                            :hideSelected="true"
                                            placeholder="Välj lokal"
                                            selectLabel=""
                                            deselectLabel=""
                                            :multiple="true">
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>{{transEdit('therapists')}}</label>
                                    <multiselect
                                            v-model="selectedTherapists"
                                            :options="filterTherapists"
                                            track-by="name"
                                            label="name"
                                            :showLabels="false"
                                            :hideSelected="true"
                                            placeholder="Välj terapeut"
                                            selectLabel=""
                                            deselectLabel=""
                                            :multiple="true">
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>{{transEdit('treatments')}}</label>
                                    <multiselect
                                            v-model="selectedTreatments"
                                            :options="filterTreatments"
                                            track-by="name"
                                            label="name"
                                            :showLabels="false"
                                            :hideSelected="true"
                                            placeholder="Välj behandling"
                                            selectLabel=""
                                            deselectLabel=""
                                            :multiple="true">
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                        <flash></flash>
                        <div class="row">
                            <div class="col-lg-6">
                                <calendar :ajax-url="ajaxUrl"
                                          date-key="start"
                                          @daySelected="setDate"
                                          ref="calendar"
                                          :disablePastDays="true"
                                          :initial-date="initialDate"
                                ></calendar>
                            </div>
                            <div class="col-lg-6 d-flex flex-column">
                                <h4 v-if="date" class="mt-4 mt-lg-0">{{date.date.format('YYYY-MM-DD')}}</h4>
                                <div v-if="date" class="schedule-list">
                                    <div v-for="schedule in date.events" class="border mt-2 mb-2 p-2 schedule-slot rounded">
                                        <div>
                                            <div class="h6 font-weight-bold">{{getTime(schedule.start)}} - {{getTime(schedule.end)}}</div>
                                            <div class="text-muted">{{schedule.location.name}}  {{schedule.location.city ? schedule.location.city.name : ''}}</div>
                                            <div class="text-muted">{{getTreatmentString(schedule)}}</div>
                                            <div class="text-muted"><img class="round-profile-picture" :src="'/therapist_profile_picture/'+schedule.therapist.profile_picture_path"> {{schedule.therapist.user.name}}</div>
                                        </div>
                                        <div class="d-flex flex-column justify-content-between">
                                            <button class="btn btn-primary book-btn" @click="selectSchedule(schedule)" v-if="!cannot_book && !schedule.booking"><i class="fa fa-plus"></i>
                                                {{transEdit('book')}}
                                            </button>
                                            <button class="btn btn-link text-primary"  v-else-if="!cannot_book && bookedByMe(schedule) && !schedule.booking.booking_batch.confirmed"  disabled>
                                                <i class="fa fa-check"></i> Reserverad av dig
                                            </button>
                                            <button class="btn btn-link text-success"  v-else-if="!cannot_book && bookedByMe(schedule) && schedule.booking.booking_batch.confirmed"  disabled>
                                                <i class="fa fa-check"></i> Bokad av dig
                                            </button>
                                            <button class="btn btn-link text-danger book-btn"  v-else-if="!cannot_book && schedule.booking"  disabled>
                                                <span><i class="fa fa-ban"></i> Bokad</span>
                                            </button>
                                            <template v-if="canQueue(schedule)">
                                                <button type="button" @click="queueForSchedule(schedule)" class="btn btn-outline-primary book-btn">
                                                    <span>{{transEdit('queue-for-time-short')}}</span>
                                                </button>
                                            </template>
                                            <template v-else-if="isQueued(schedule) && !bookedByMe(schedule)">
                                                <template v-if="schedule.booking">
                                                    <button type="button" class="btn btn-outline-danger book-btn" @click="removeFromQueue(schedule)">
                                                        <span>{{transEdit('stop-queue-for-time-short')}}</span>
                                                    </button>
                                                </template>
                                                <template v-else>
                                                    <div class="text-success text-center">Köad tid ledig!</div>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="d-flex justify-content-center align-content-center"><div class="h4 text-black-50 mt-4 mt-lg-0">{{transEdit('choose-day')}}</div></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import BookingModal from './BookingModal.vue'
    import QueueModal from './QueueModal.vue'
    import AbortQueueModal from './AbortQueueModal.vue'
    export default {
        name: "booking",
        props: ['therapists', 'treatments', 'reservations', 'user_id', 'cannot_book', 'company', 'locations',
            'consultant', 'initial_location', 'initial_date'],
        data(){
            let initialLocationsArray = [];
            let initialShowFilters = false;
            let initialDate = null;

            if (this.initial_location) {
                initialShowFilters = true;
                initialLocationsArray.push(this.initial_location)
            }

            if (this.initial_date && this.initial_date != "null") {
                initialDate = moment(this.initial_date, "Y-M-D");
            }

            return {
                date: null,
                selectedSchedule: null,
                selectedLocations: initialLocationsArray,
                selectedTherapists: [],
                selectedTreatments: [],
                showFilters: initialShowFilters,
                initialDate: initialDate,
            }
        },
        computed: {
          sessionId(){
              return window.Laravel.sessionId;
          },
          ajaxUrl(){
              let first = true;
              let url = '/book/filterevents';

              let symbol = '?';

              this.selectedLocations.forEach((location) => {
                  url += symbol+'location_ids[]='+location.id;
                  if(first){
                      symbol = '&';
                      first = false;
                  }
              });

              this.selectedTherapists.forEach((therapist) => {
                  url += symbol+'therapist_ids[]='+therapist.id;
                  if(first){
                      symbol = '&';
                      first = false;
                  }
              });

              this.selectedTreatments.forEach((treatment) => {
                  url += symbol+'treatment_ids[]='+treatment.id;
                  if(first){
                      symbol = '&';
                      first = false;
                  }
              });

              url += symbol+'company_id='+this.company.id;

              return url;
          },
          filterLocations() {
              let simplifiedLocations = [];
              if(this.locations){
                  this.locations.forEach((location) => {
                      let tempAddressString = location.name;
                      if (location.city) {
                          tempAddressString += ' ' + location.city.name;
                      }
                      simplifiedLocations.push({
                          id: location.id,
                          address:  tempAddressString,
                      });
                  });
              }

              return simplifiedLocations;
          },
          filterTherapists() {
              let simplifiedTherapists = [];
              if(this.therapists){
                  this.therapists.forEach((therapist) => {
                      simplifiedTherapists.push({
                          id: therapist.id,
                          name: therapist.user.name,
                      });
                  });
              }
              return simplifiedTherapists;
          },
            filterTreatments() {
                let simplifiedTreatments = [];
                if(this.treatments){
                    this.treatments.forEach((treatment) => {
                        simplifiedTreatments.push({
                            id: treatment.id,
                            name: treatment.name,
                        });
                    });
                }
                return simplifiedTreatments;
            },
        },
        methods: {
            setDate(date){
                this.date = date;
            },
            canQueue(schedule) {
                return schedule.customers && (! (schedule.customers.length > 0) && schedule.booking && ! this.bookedByMe(schedule));
            },
            isQueued(schedule) {
                return schedule.customers && schedule.customers.length > 0;
            },
            getDateTime(dateString){
                return moment(dateString).format('YYYY-MM-DD HH:mm')
            },
            getTime(dateString){
                return moment(dateString).format('HH:mm')
            },
            bookedByMe(schedule){
                if(schedule.booking && !schedule.booking.user_id) {
                    return !this.user_id && window.Laravel.sessionId == schedule.booking.session_id;
                } else if(schedule.booking) {
                    return schedule.booking.user_id == this.user_id;
                }

                return false;
            },
            selectSchedule(schedule){
                this.selectedSchedule = schedule;
                this.$modal.show(BookingModal, {
                    'schedule': this.selectedSchedule,
                    'company': this.company,
                    'consultant': this.consultant
                }, {
                    'width': '100%',
                    'height': 'auto',
                    'max-width': 800,
                    'adaptive': true,
                    'clickToClose': false,

                }, {
                    'before-close': this.closeModal
                })
            },
            queueForSchedule(schedule){
                this.$modal.show(QueueModal, {
                    'schedule': schedule,
                    'consultant': this.consultant
                }, {
                    'width': '100%',
                    'height': 'auto',
                    'max-width': 800,
                    'adaptive': true,
                    'clickToClose': false,
                }, {
                    'before-close': this.closeModal
                })
            },
            removeFromQueue(schedule){
                this.$modal.show(AbortQueueModal, {
                    'schedule': schedule,
                }, {
                    'width': '100%',
                    'height': 'auto',
                    'max-width': 800,
                    'adaptive': true,
                    'clickToClose': false,
                }, {
                    'before-close': this.closeModal
                })
            },
            closeModal (event) {
                this.$refs.calendar.ajaxEvents();
                this.$refs.reservations.getReservations();
                window.scrollTo(0, 0);
            },
            getTreatmentString(schedule){
                if(schedule.treatments.length > 1){
                    return schedule.treatments.length + " " + this.transEdit('possible-treatment-types').toLowerCase();
                }

                return schedule.treatments[0].name;
            }
        }

    }
</script>
<style scoped>
    .schedule-slot{
        display: flex;
        justify-content: space-between;
    }

    .book-btn {
        width: 100px;
    }
</style>
